(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc2-hair-bundle-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-wc2hbs]');
    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const tray = document.querySelector('[data-wc2hbs-tray]');
      const status = root.querySelector('[data-wc2hbs-status]');
      const count = tray && tray.querySelector('[data-wc2hbs-count]');
      const itemsRoot = tray && tray.querySelector('[data-wc2hbs-items]');
      const clearButton = tray && tray.querySelector('[data-wc2hbs-clear]');
      const submitButton = tray && tray.querySelector('[data-wc2hbs-submit]');
      const feedback = tray && tray.querySelector('[data-wc2hbs-feedback]');
      if (!tray || !status || !count || !itemsRoot || !clearButton || !submitButton || !feedback) return;

      const sessionKey = 'wigcut_hair_selection_session_v1';
      const hashParams = new URLSearchParams(window.location.hash.slice(1));
      const hashToken = hashParams.get('hair-selection');
      const previousToken = window.sessionStorage.getItem(sessionKey) || '';
      let token = hashToken || previousToken;
      if (hashToken) {
        if (previousToken && previousToken !== hashToken) {
          window.sessionStorage.removeItem(`wigcut_hair_selection_draft_v2:${previousToken}`);
          window.sessionStorage.removeItem(`wigcut_hair_selection_attempt_v1:${previousToken}`);
        }
        window.sessionStorage.setItem(sessionKey, hashToken);
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
      }
      if (!/^[A-Za-z0-9_-]{43}$/.test(token)) return;
      // A draft or uncertain retry must never cross into another customer's case.
      const draftKey = `wigcut_hair_selection_draft_v2:${token}`;
      const attemptKey = `wigcut_hair_selection_attempt_v1:${token}`;

      const apiUrl = root.dataset.apiUrl;
      const galleryDataUrl = root.dataset.galleryDataUrl;
      const gallerySelector = root.dataset.gallerySelector || '.xo-gallery-id-14';
      const labels = {
        select: root.dataset.selectLabel || '選ぶ',
        selected: root.dataset.selectedLabel || '選択済み',
        remove: root.dataset.removeLabel || 'を外す',
        primary: root.dataset.primaryLabel || '主',
        count: root.dataset.countLabel || '選択中',
        limit: root.dataset.limitMessage || '選べる画像は3枚までです',
        ready: root.dataset.readyMessage || '画像を選んでください',
        loading: root.dataset.loadingMessage || '選択内容を確認しています',
        saving: root.dataset.savingMessage || '登録しています',
        saved: root.dataset.savedMessage || 'WIGCUTに送信しました',
        unsent: root.dataset.unsentMessage || 'この変更はまだ送信されていません',
        previousRemains: root.dataset.previousRemainsMessage || '前回送信した画像は残っています',
        sendUnknown: root.dataset.sendUnknownMessage || '送信結果を確認できませんでした',
        sendRejected: root.dataset.sendRejectedMessage || 'このリンクでは送信できません',
        resend: root.dataset.resendLabel || '変更を送る',
        sentLabel: root.dataset.sentLabel || '送信済み',
        submit: submitButton.textContent.trim(),
        error: root.dataset.errorMessage || '読み込みに失敗しました',
      };
      if (!apiUrl || !galleryDataUrl) return;

      root.hidden = false;
      tray.hidden = false;
      document.body.classList.add('wc2hbs-active');
      status.textContent = labels.loading;

      let catalog = [];
      let selectedIds = [];
      let savedIds = [];
      let saving = false;
      let pendingAttempt = null;

      const sameIds = (left, right) => left.length === right.length
        && left.every((id, index) => id === right[index]);

      const setStatus = (message, state = 'ready') => {
        status.textContent = message;
        status.dataset.state = state;
      };

      const syncTrayHeight = () => {
        document.body.style.setProperty('--wc2hbs-tray-height', `${Math.ceil(tray.getBoundingClientRect().height) + 12}px`);
      };

      const setFeedback = (message, state = 'ready') => {
        feedback.hidden = !message;
        feedback.textContent = message;
        feedback.dataset.state = state;
        window.requestAnimationFrame(syncTrayHeight);
      };

      const showSelectionState = () => {
        if (pendingAttempt && sameIds(pendingAttempt.ids, selectedIds)) {
          setStatus(labels.sendUnknown, 'error');
          setFeedback(labels.sendUnknown, 'unknown');
        } else if (savedIds.length > 0 && sameIds(selectedIds, savedIds)) {
          setStatus(labels.saved, 'saved');
          setFeedback(labels.saved, 'saved');
        } else if (selectedIds.length === 0 && savedIds.length > 0) {
          setStatus(labels.previousRemains);
          setFeedback(labels.previousRemains, 'dirty');
        } else if (selectedIds.length > 0) {
          setStatus(labels.unsent);
          setFeedback(labels.unsent, 'dirty');
        } else {
          setStatus(labels.ready);
          setFeedback('', 'ready');
        }
      };

      const saveDraft = () => {
        window.sessionStorage.setItem(draftKey, JSON.stringify(selectedIds));
      };

      const clearAttempt = () => {
        pendingAttempt = null;
        window.sessionStorage.removeItem(attemptKey);
      };

      const currentItems = () => selectedIds
        .map((id) => catalog.find((item) => item.id === id))
        .filter(Boolean);

      const syncGrid = () => {
        document.querySelectorAll(`${gallerySelector} .xo-grid-item[data-wc2hbs-id]`).forEach((gridItem) => {
          const selected = selectedIds.includes(gridItem.dataset.wc2hbsId);
          gridItem.dataset.wc2hbsSelected = selected ? 'true' : 'false';
          const button = gridItem.querySelector('.wc2hbs-pick');
          if (button) {
            button.textContent = selected ? labels.selected : labels.select;
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            button.disabled = saving;
          }
        });
      };

      const renderTray = () => {
        const selected = currentItems();
        count.textContent = `${labels.count} ${selected.length} / 3`;
        clearButton.hidden = selected.length === 0;
        clearButton.disabled = saving;
        submitButton.setAttribute('aria-busy', saving ? 'true' : 'false');
        submitButton.disabled = selected.length === 0 || saving || sameIds(selectedIds, savedIds);
        submitButton.textContent = saving ? labels.saving
          : sameIds(selectedIds, savedIds) && savedIds.length > 0 ? labels.sentLabel
            : savedIds.length > 0 ? labels.resend : labels.submit;
        itemsRoot.replaceChildren();

        selected.forEach((item, index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'wc2hbs-tray__item';
          const image = document.createElement('img');
          image.src = item.url;
          image.alt = item.title;
          image.loading = 'lazy';
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'wc2hbs-tray__remove';
          remove.textContent = '×';
          remove.setAttribute('aria-label', `${item.title}${labels.remove}`);
          remove.disabled = saving;
          remove.addEventListener('click', () => {
            if (saving) return;
            selectedIds = selectedIds.filter((id) => id !== item.id);
            clearAttempt();
            saveDraft();
            renderTray();
            syncGrid();
            showSelectionState();
          });
          wrapper.append(image, remove);
          if (index === 0) {
            const primary = document.createElement('span');
            primary.className = 'wc2hbs-tray__primary';
            primary.textContent = labels.primary;
            wrapper.append(primary);
          }
          itemsRoot.append(wrapper);
        });
        window.requestAnimationFrame(syncTrayHeight);
      };

      const toggleSelection = (id) => {
        if (saving) return;
        if (selectedIds.includes(id)) {
          selectedIds = selectedIds.filter((selectedId) => selectedId !== id);
        } else if (selectedIds.length >= 3) {
          setStatus(labels.limit, 'error');
          setFeedback(labels.limit, 'error');
          return;
        } else {
          selectedIds = [...selectedIds, id];
        }
        clearAttempt();
        saveDraft();
        renderTray();
        syncGrid();
        showSelectionState();
      };

      const bindGalleryItems = () => {
        const gallery = document.querySelector(gallerySelector);
        if (!gallery || catalog.length === 0) return false;
        gallery.querySelectorAll('.xo-grid-item[data-index]').forEach((gridItem) => {
          const index = Number.parseInt(gridItem.dataset.index || '', 10);
          const item = catalog.find((candidate) => candidate.index === index);
          if (!item || gridItem.dataset.wc2hbsId) return;
          gridItem.dataset.wc2hbsId = item.id;
          const wrapper = gridItem.querySelector('.grid-item__wrapper');
          if (!wrapper) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'wc2hbs-pick';
          button.setAttribute('aria-label', `${item.title} ${labels.select}`);
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            toggleSelection(item.id);
          });
          wrapper.append(button);
        });
        syncGrid();
        return gallery.querySelectorAll('.xo-grid-item[data-wc2hbs-id]').length > 0;
      };

      const observeGallery = () => {
        if (bindGalleryItems()) return;
        const observer = new MutationObserver(() => {
          if (bindGalleryItems()) observer.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        window.setTimeout(() => observer.disconnect(), 15000);
      };

      clearButton.addEventListener('click', () => {
        if (saving) return;
        selectedIds = [];
        clearAttempt();
        saveDraft();
        renderTray();
        syncGrid();
        showSelectionState();
      });

      submitButton.addEventListener('click', async () => {
        if (saving || selectedIds.length === 0 || sameIds(selectedIds, savedIds)) return;
        const submittedIds = [...selectedIds];
        const idempotencyKey = pendingAttempt && sameIds(pendingAttempt.ids, submittedIds)
          ? pendingAttempt.key : window.crypto.randomUUID();
        pendingAttempt = { ids: submittedIds, key: idempotencyKey };
        window.sessionStorage.setItem(attemptKey, JSON.stringify(pendingAttempt));
        saving = true;
        renderTray();
        syncGrid();
        setStatus(labels.saving);
        setFeedback(labels.saving, 'sending');
        let rejected = false;
        try {
          const response = await fetch(apiUrl, {
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              galleryItemIds: submittedIds,
              primaryGalleryItemId: submittedIds[0],
              idempotencyKey,
            }),
          });
          const result = await response.json();
          if (!response.ok || !result.ok) {
            rejected = response.status >= 400 && response.status < 500;
            throw new Error(result.error || labels.error);
          }
          savedIds = submittedIds;
          clearAttempt();
          window.sessionStorage.removeItem(draftKey);
          setStatus(labels.saved, 'saved');
          setFeedback(labels.saved, 'saved');
        } catch {
          const message = rejected ? labels.sendRejected : labels.sendUnknown;
          setStatus(message, 'error');
          setFeedback(message, rejected ? 'error' : 'unknown');
        } finally {
          saving = false;
          renderTray();
          syncGrid();
        }
      });

      Promise.all([
        fetch(apiUrl, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(galleryDataUrl),
      ]).then(async ([sessionResponse, catalogResponse]) => {
        const session = await sessionResponse.json();
        if (!sessionResponse.ok || !session.ok) throw new Error(session.error || labels.error);
        if (!catalogResponse.ok) throw new Error(labels.error);
        const data = await catalogResponse.json();
        const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        catalog = Array.isArray(data.images) ? data.images.flatMap((image, index) => {
          if (!image || typeof image !== 'object' || !uuid.test(image._id || '')) return [];
          let url;
          try {
            url = new URL(image.url);
          } catch {
            return [];
          }
          if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') return [];
          const title = typeof image.title === 'object' && image.title
            ? image.title.ja || image.title.en
            : image.title;
          return [{ index, id: image._id, url: url.toString(), title: title || `毛束イメージ ${index + 1}` }];
        }) : [];
        if (catalog.length === 0) throw new Error(labels.error);

        let draft = null;
        try {
          const draftRaw = window.sessionStorage.getItem(draftKey);
          const parsed = draftRaw === null ? null : JSON.parse(draftRaw);
          if (Array.isArray(parsed)) draft = parsed;
        } catch {
          draft = null;
        }
        savedIds = session.selection && Array.isArray(session.selection.galleryItemIds)
          ? session.selection.galleryItemIds
          : [];
        selectedIds = (draft === null ? savedIds : draft)
          .filter((id, index, values) => catalog.some((item) => item.id === id) && values.indexOf(id) === index)
          .slice(0, 3);
        try {
          const storedAttempt = JSON.parse(window.sessionStorage.getItem(attemptKey) || 'null');
          if (storedAttempt && Array.isArray(storedAttempt.ids)
            && typeof storedAttempt.key === 'string'
            && /^[0-9a-f-]{36}$/i.test(storedAttempt.key)
            && sameIds(storedAttempt.ids, selectedIds)
            && !sameIds(selectedIds, savedIds)) {
            pendingAttempt = storedAttempt;
          } else {
            clearAttempt();
          }
        } catch {
          clearAttempt();
        }
        renderTray();
        observeGallery();
        showSelectionState();
      }).catch(() => {
        window.sessionStorage.removeItem(sessionKey);
        token = '';
        tray.hidden = true;
        setStatus(labels.error, 'error');
      });

      window.addEventListener('resize', syncTrayHeight, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
